/* nie ma dostępu do obiektu history */

/* 
 <938 : problem z podmenu
 <540 : dodaj ogłoszenie - nowe
 <500 : tylko same ikony: ukrycie tekstu "wyszukaj", dodaj

*/

import React from 'react'
import { Button, Container, Menu, Icon, Image, Dropdown } from 'semantic-ui-react'
import { useUser } from '../../common/contexts/UserProvider';
import { Link, useHistory } from 'react-router-dom';

import { useMediaQuery } from 'react-responsive';

import DarkMode from './DarkModeToggle/DarkMode';

const NavBar = () => {  // navigate bez route

  // schodząc w dół poszczególne są ukrywane 1 to nawyższy rozmiar
  // query ma charakter logiczny if(min-width...) tzn. zwraca true od i POWYŻEJ
  const p1 = useMediaQuery({ query: "(min-width:1200px)" }); // pełen układ
  const p2 = useMediaQuery({ query: "(min-width:1100px)" }); // ukrycie tekstu 'ogłoszenie'
  const p3 = useMediaQuery({ query: "(min-width:1000px)" }); // ukrycie tekstu 'motokomis.pl'
  const p4 = useMediaQuery({ query: "(min-width:810px)" }); // ukrycie ikonki logo
  const p5 = useMediaQuery({ query: "(min-width:650px)" }); // ukrycie tekstu zaloguj
  const p6 = useMediaQuery({ query: "(min-width:580px)" }); // warunek padding przycisku, ukrycie tekstu 'nowe'
  const p7 = useMediaQuery({ query: "(min-width:500px)" }); // ukrycie tekstu 'wyszukaj'
  
  const size = { p1, p2, p3, p4, p5, p6, p7 } // odwrotna numeracja

  const history = useHistory();

  const { user, setUser } = useUser();  // wczytanie z providera obiektu user

  const btnPlusText = () => {  // też jest konieczność ustawiania odpowiedniego padding-a
    if (size.p1) // maksymalny ekran i powyżej - pełny tekst
      return 'Nowe ogłoszenie';
    else if (!size.p6) // punkt zupełnego ukrycia
      return '';

      return 'Nowe'; // pomiędzy, tj. p2, p3, p4, p5, p6
  }

  const logout = () => {
    localStorage.removeItem('token');  // konieczne
    setUser('');
    // przekierowanie  
    history.push({
      pathname: '/msg',
      state: {
        type: 'success',
        message: 'Nastąpiło poprawne wylogowanie'  // error.response.data.message
      }
    });
  }

  const btnCreateAdvClicked = () => {
    history.push("/advs/cars/create");
  }

  return (
    
    <Menu fixed="top" sticky={true.toString()} inverted>
      <Container>
        {/* header jest ukrywany na małym ekranie - to miejsce dla toggler-a */}
        {size.p4 && (
          <Menu.Item header>
            <Link to="/">
            <img src="/assets/logo.png" alt="logo" style={{ marginRight: '10px', width: '36px', position: 'relative', top: '2px' }} />
              {size.p2 && (<span style={{position: 'relative', top: '-6px'}}><span style={{color: 'orange'}}>moto</span>komis<span style={{fontStyle: 'italic', color: '#1f98ad'}}>.pl</span></span>)}
            </Link>
          </Menu.Item>
        )}        

        <Menu.Item>
              <Link to="/advs/search">
                <Icon name="search" />
                {size.p7 && (<b>Wyszukaj</b>)}
              </Link>
        </Menu.Item>
        <Menu.Item>{/* kiedy jest sam znak plus padding 20-5, a kiedy jest tekst: 20-20 */}
          <Button positive icon="plus" style={!size.p6 ? {paddingLeft: 20, paddingRight: 5} : {paddingLeft: 20, paddingRight: 20}} content={btnPlusText()} onClick={btnCreateAdvClicked}/>
        </Menu.Item>

        {/* ==== prawa część paska ==== */}

        <Menu.Item position='right'>
          <DarkMode/>
        </Menu.Item>

        {user && ( // zalogowany
          <Menu.Item position='right'>
            {true && (
             <Image avatar style={{padding: 1, height: 36, width: 36}} spaced='right' src={user.image || '/assets/user.png'} />
            )}
            <Dropdown pointing='top left' text={user}>
              <Dropdown.Menu direction='left'>
                <div className="dropdownMenuItems"> {/* bez objęcia we własnego div-a css nie działało */}
                  <Dropdown.Item
                    as={Link}
                    to={'/profile/own-advs'}
                    text='Moje ogłoszenia'
                    icon='folder outline'
                  />
                  <Dropdown.Item
                    as={Link}
                    to={'/profile/update-password'}
                    text='Zmiana hasła'
                    icon='user'
                  />
                  <Dropdown.Item as={Link} to='' text='Wyloguj' icon='power' onClick={logout} />
                </div>
              </Dropdown.Menu>
            </Dropdown>
          </Menu.Item>
        )}
        {(user === '') && ( // nie zalogowany, przy undefined nie wyswietlac nic
            <Menu.Item position='right'>
              <Link to="/users/login">
                <Icon name="sign-in" />
                  {size.p5 && (<b>Zaloguj</b>)}
                </Link>
            </Menu.Item>
        )}
        {/* ==== prawa część paska ==== */}

      </Container>
    </Menu >
  )
}

export default NavBar